export const VIDEO_ELEMENT_DEFAULT_ATTRS: Partial<HTMLVideoElement> = {
  autoplay: true,
  muted: true,
  controls: true,
};

export const setVideoAttributes = ({
  videoElement,
  videoAttributes,
}: {
  videoElement: HTMLVideoElement;
  videoAttributes?: Partial<HTMLVideoElement>;
}): void => {
  Object.assign(
    videoElement,
    // if ever would need logic to decide either use default I suggest
    // passing additional prop to object with default value as true and check
    // and check it below. Although I see not such business case, better to re-write
    // attributes from calling setVideoAttributes() place.
    VIDEO_ELEMENT_DEFAULT_ATTRS,
    videoAttributes,
  );
};
